import { create } from 'zustand';

export type ConsoleLevel = 'log' | 'info' | 'warn' | 'error';

export interface ConsoleEntry {
  id: string;
  level: ConsoleLevel;
  message: string;
  source: string;
  timestamp: number;
}

interface ConsoleState {
  entries: ConsoleEntry[];
  add: (entry: Omit<ConsoleEntry, 'id' | 'timestamp'>) => void;
  clear: () => void;
}

const MAX_ENTRIES = 500;

/**
 * Backs the workbench's bottom Console panel. Fed by script `console.*`
 * calls (scriptSandbox) and by the request/response lifecycle (send
 * start/success/failure) so there's one place to look for "what just
 * happened", matching Postman's own Console.
 */
export const useConsoleStore = create<ConsoleState>((set) => ({
  entries: [],
  add: (entry) =>
    set((state) => ({
      entries: [
        ...state.entries.slice(-(MAX_ENTRIES - 1)),
        { ...entry, id: crypto.randomUUID(), timestamp: Date.now() },
      ],
    })),
  clear: () => set({ entries: [] }),
}));
